import {StateType} from '@/types'
import {Module} from 'vuex'

const state = {
  hotCategory: 0,
}
type ProductsStateType = typeof state

const products: Module<ProductsStateType, StateType> = {
  namespaced: true,
  ...state,
}

export {ProductsStateType, state}
export default products
